'use client';

import {
  type BaseComponentProps,
  type ContentfulImageType,
  filterEntriesByType,
} from '@bedrock/core/contentful';
import {
  type ContentfulComposableElementType,
  type ContentfulInlineFrameType,
} from 'lib/contentful/types';
import { LazyWrap } from 'ui/common/lazy-wrap';
import { MediaImage } from 'ui/components';

type FlipSnackProps = BaseComponentProps<ContentfulComposableElementType>;

function FlipSnack({ fields }: Readonly<FlipSnackProps>) {
  const inlineFrames = filterEntriesByType<ContentfulInlineFrameType>(
    fields.elements,
    'inlineFrame',
  );

  if (!inlineFrames.length) return null;

  const [frame] = inlineFrames;

  if (!frame) return null;

  const [imageEl] = filterEntriesByType<ContentfulImageType>(fields.elements, 'image');

  return (
    <div className="relative">
      {imageEl ? <MediaImage asBackground classNames={{ root: 'z-0' }} image={imageEl} /> : null}
      <section aria-label="FlipSnack menu" className="py-5xl relative min-h-[700px] w-full">
        <LazyWrap className="relative z-10 m-auto flex w-full justify-center md:max-w-[768px] lg:max-w-[1024px]">
          <iframe
            allow="autoplay; clipboard-read; clipboard-write"
            allowFullScreen
            className="aspect-[0.74]"
            src={frame.url}
            title={frame.title}
            width="1024px"
          />
        </LazyWrap>
      </section>
    </div>
  );
}

export default FlipSnack;
